module.exports = __webpack_public_path__ + "img/navigate-logo.17107850.svg";